<template>
  <div>
    <ul class="navbar-nav">
      <template v-for="actionPermission in actionPermissions">
        <template v-if="actionPermission.children.length > 0">
          <li :key="actionPermission.id">
            <router-link
              active-class="active"
              :to="link(actionPermission.menu) ? link(actionPermission.menu) : 'javascript:void(0)'"
            >{{ actionPermission.name }}</router-link>
            <ul class="dropdown-menu">
              <li
                v-for="children in actionPermission.children"
                :key="children.id"
                active-class="active"
              >
                <router-link
                  :key="children.id"
                  :to="link(children.menu)"
                >{{ children.name }}</router-link>
              </li>
            </ul>
          </li>
        </template>
        <template v-else>
          <router-link
            tag="li"
            active-class="active"
            :key="actionPermission.id"
            :to="link(actionPermission.menu)"
          >
            <a href="#">{{ actionPermission.name }}</a>
          </router-link>
        </template>
      </template>
    </ul>
  </div>
</template>

<script>
import User from '@/model/user'

export default {
  data () {
    return {
      actionPermissions: null
    }
  },
  watch: {
    $route: 'fetchData'
  },
  created () {
    this.fetchData()
  },
  methods: {
    fetchData () {
      User.getActionPermissionsByType('menu')
        .then((response) => {
          this.actionPermissions = response.data
        })
    },
    link (menu) {
      switch (menu.view) {
        case 'url':
          return '/' + menu.url
        case 'anchor':
          return '/' + menu.url
        default:
          return '#'
      }
    }
  }
}
</script>
